import { GameVars } from "../../../GameVars";
import { GameConstants } from "../../../GameConstants";
import { BananaSpine } from "./BananaSpine";

export class BananaLayer extends Phaser.GameObjects.Container {

    private banana: BananaSpine;
    private popcornTween: Phaser.Tweens.Tween;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = GameConstants.GAME_HEIGHT;

        this.scaleX = GameVars.scaleX;

        this.banana = new BananaSpine(this.scene);
        this.banana.y = -200;
        this.banana.x = 220;
        this.add(this.banana);

        this.visible = false;
    }

    public showBananaPopcorns(): void {

        this.visible = true;
        this.banana.visible = true;

        this.banana.setAvatarState("fold", true);
        this.banana.y = 0;

        this.popcornTween = this.scene.tweens.add({
            targets: this.banana,
            y: -200,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 5000
        });
    }

    public hideBananaPopcorns(): void {

        if (this.popcornTween) {
            this.popcornTween.remove();
        }

        this.scene.tweens.add({
            targets: this.banana,
            y: 0,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 250,
            onComplete: () => {
                this.visible = false;
                this.banana.visible = false;
            },
            onCompleteScope: this
        });
    }

    public showBananaBluff(): void {

        this.visible = true;
        this.banana.visible = true;

        this.banana.setAvatarState("victory-bluff");
        this.banana.y = 0;

        this.popcornTween = this.scene.tweens.add({
            targets: this.banana,
            y: -200,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 250,
            onComplete: () => {
                this.scene.tweens.add({
                    targets: this.banana,
                    y: 0,
                    ease: Phaser.Math.Easing.Linear.Linear,
                    duration: 250,
                    delay: 1500,
                    onComplete: () => {
                        this.visible = false;
                        this.banana.visible = false;
                    },
                    onCompleteScope: this
                });
            },
            onCompleteScope: this
        });
    }

    public showBananaRise(): void {
        
        this.visible = true;
        this.banana.visible = true;

        let num = 3;

        if (GameVars.blindsPosition < 4) {
            num = 1;
        } else if (GameVars.blindsPosition < 8) {
            num = 2;
        }

        this.banana.setAvatarState("rise" + num);
        this.banana.y = 0;

        this.popcornTween = this.scene.tweens.add({
            targets: this.banana,
            y: -200,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 250,
            onComplete: () => {
                this.scene.tweens.add({
                    targets: this.banana,
                    y: 0,
                    ease: Phaser.Math.Easing.Linear.Linear,
                    duration: 250,
                    delay: 1500,
                    onComplete: () => {
                        this.visible = false;
                        this.banana.visible = false;
                    },
                    onCompleteScope: this
                });
            },
            onCompleteScope: this
        });
    }
}
